import { useQuery } from '@hooks/reactQuery';

import { getMiddlewareSMO } from '@api/middlewareSMO';

import { extractQueryParams } from '@utils/common';

import { TPartialPick } from '@interfaces/common/genericWithModifying';
import { IMiddlewareSMODTO } from '@interfaces/middlewareSMO/dto/middlewareSMO';
import { IMiddlewareSMO } from '@interfaces/middlewareSMO/middlewareSMO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { MIDDLEWARE_SMO } from '@constants/queryKeys';

interface IUseQueryMiddlewareSMOReturned {
	middlewareSMOData: IMiddlewareSMO[];
	allMiddlewareSMOData: IMiddlewareSMO[];
	countOfRecords: number;
	isLoadingMiddlewareSMO: boolean;
}

const useQueryMiddlewareSMO = (params: TPartialPick<IMiddlewareSMODTO, 'status' | 'systemId'>): IUseQueryMiddlewareSMOReturned => {
	const {
		page,
		pageSize,
	} = params;

	const {
		data,
		allData,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [MIDDLEWARE_SMO, params],
		queryFn: extractQueryParams(getMiddlewareSMO),
		enabled: [!!page, !!pageSize],
		allowedRoles: [EUserRoles.smoLightViewer, EUserRoles.smoLightUpdater],
		fetchAllData: true,
		...refetchOptions,
	});

	return {
		middlewareSMOData: data?.items || [],
		allMiddlewareSMOData: allData?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingMiddlewareSMO: (isLoading && !!data) || isFetching,
	};
};

export default useQueryMiddlewareSMO;
